// src/Views/RiskManagement/RiskManagement.js
import React from 'react';
import { Icon } from '@iconify/react';
import './RiskManagement.css';

const RiskManagement = () => {
    return (
        <section className="rm">
            <div className="rm__inner">
                
                <header className="rm__header">
                    <div className="rm__eyebrow">
                        <Icon icon="solar:shield-warning-linear" className="rm__eyebrow-icon" />
                        <span>Mandatory Protocols</span>
                    </div>
                    <h2 className="rm__title">
                        If you don&apos;t control risk,<br />
                        <span className="rm__highlight">you&apos;re just gambling.</span>
                    </h2>
                    <p className="rm__subtitle">
                        AiPredict is built on the principle of survival. Every slip and every crypto trade 
                        must be anchored to strict rules that protect your bankroll from market volatility.
                    </p>
                </header>

                <div className="rm__grid">
                    
                    {/* Football Card */}
                    <section className="rm__card rm__card--football">
                        <div className="rm__card-head">
                            <div className="rm__icon-wrap rm__icon-wrap--football">
                                <Icon icon="solar:football-outline" />
                            </div>
                            <h3 className="rm__card-title">Football Protocols</h3>
                        </div>
                        
                        <ul className="rm__list">
                            <li>
                                <Icon icon="solar:check-circle-linear" className="rm__list-icon" />
                                <p><strong>Fixed Staking:</strong> Never bet more than 1-2% of your total bankroll on a single slip.</p>
                            </li>
                            <li>
                                <Icon icon="solar:check-circle-linear" className="rm__list-icon" />
                                <p><strong>Stop Loss:</strong> If you hit a daily loss limit (e.g., 5%), stop. Do not chase losses.</p>
                            </li>
                            <li>
                                <Icon icon="solar:check-circle-linear" className="rm__list-icon" />
                                <p><strong>Slip Health:</strong> AiPredict flags low-probability setups. Respect the data.</p>
                            </li>
                            <li>
                                <Icon icon="solar:check-circle-linear" className="rm__list-icon" />
                                <p><strong>Edge over Odds:</strong> Don't chase 100x odds. Focus on consistent, lower-odds edges.</p>
                            </li>
                        </ul>
                    </section>

                    {/* Crypto Card */}
                    <section className="rm__card rm__card--crypto">
                        <div className="rm__card-head">
                            <div className="rm__icon-wrap rm__icon-wrap--crypto">
                                <Icon icon="solar:chart-2-outline" />
                            </div>
                            <h3 className="rm__card-title">Crypto Protocols</h3>
                        </div>

                        <ul className="rm__list">
                            <li>
                                <Icon icon="solar:check-circle-linear" className="rm__list-icon" />
                                <p><strong>Entry Zones:</strong> Never FOMO. Only enter when price is within the AI's defined zone.</p>
                            </li>
                            <li>
                                <Icon icon="solar:check-circle-linear" className="rm__list-icon" />
                                <p><strong>Hard Stops:</strong> Every trade idea includes an invalidation level. Respect it instantly.</p>
                            </li>
                            <li>
                                <Icon icon="solar:check-circle-linear" className="rm__list-icon" />
                                <p><strong>No Hope Mode:</strong> When a trade is marked "Canceled" by the AI, exit the position.</p>
                            </li>
                            <li>
                                <Icon icon="solar:check-circle-linear" className="rm__list-icon" />
                                <p><strong>Volatility Awareness:</strong> Crypto moves fast. Reduce position size during high volatility.</p>
                            </li>
                        </ul>
                    </section>

                </div>

                <footer className="rm__footer">
                    <div className="rm__alert">
                        <Icon icon="solar:bell-bing-linear" className="rm__alert-icon" />
                        <div>
                            <strong>Final Warning:</strong> Nothing on AiPredict is financial advice. 
                            You are responsible for your own decisions. Protect your capital first.
                        </div>
                    </div>
                </footer>

            </div>
        </section>
    );
};

export default RiskManagement;